<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm row justify-between items-center">
      <div class="text-subtitle1 text-bold">
        <q-icon name="phone" style="font-size: 25px; padding-right: 0.1rem" />
        {{isPrimary ? 'Primary' : 'Secondary'}} Phone Number
      </div>
      <q-btn
        color="primary"
        label="Save"
        size="sm"
        :loading="saving"
        @click="handleSubmit"
      />
    </q-card-section>

    <q-separator />
    <q-card-section>
      <div class="row q-col-gutter-x-sm">
        <app-editable-input
          :loadingData="loading"
          class="col"
          :data="number"
          type="tel"
          text="Phone *"
          name="number"
          disablePhoneCall
          mask="+1 (###) ### - ####"
          unmasked-value
          @input="handleChange"
          :error="$v.number.$error"
        />
        <app-editable-input
          :loadingData="loading"
          class="col"
          :data="extension"
          text="Extension *"
          name="extension"
          @input="handleChange"
          :error="$v.extension.$error"
        />
      </div>
      <app-phone-number-password-dialog ref="phoneNumberPasswordDialogRef" />
    </q-card-section>
  </q-card>
</template>

<script>
import graphql from '@client/graphql';
import { required } from 'vuelidate/lib/validators';
import AppEditableInput from '@client/components/form/editable-input';
import AppPhoneNumberPasswordDialog from '@client/components/dialogs/phone-number-password-dialog';

export default {
  name: 'AppRingCentralIntegrationCard',
  props: ['isPrimary'],
  components: {
    AppEditableInput,
    AppPhoneNumberPasswordDialog
  },
  validations: {
    number: { required },
    extension: { required }
  },
  apollo: {
    phoneNumber() {
      let gql = graphql.queries.getPrimaryPhoneNumber;
      if (!this.isPrimary) {
        gql = graphql.queries.getSecondaryPhoneNumber;
      }

      return {
        query: gql,
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        error(error) {
          this.error = error;
        },
        update(data) {
          return this.isPrimary ? data.primaryPhoneNumber : data.secondaryPhoneNumber;
        },
        result(result) {
          if (result.loading) return;

          if (this.isPrimary) {
            Object.assign(this, result.data.primaryPhoneNumber);
          } else {
            Object.assign(this, result.data.secondaryPhoneNumber);
          }
        }
      };
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      saving: false,
      number: null,
      extension: null
    };
  },
  methods: {
    handleChange(event) {
      this[event.name] = event.model;
      this.delayTouch(this.$v[event.name], this.$options.touchMap);
    },
    async handleSave(password) {
      this.saving = true;
      try {
        await this.$apollo.mutate({
          mutation: graphql.mutations.setPhoneNumber,
          variables: {
            number: this.number.startsWith('+') ? this.number : `+1${this.number}`,
            extension: this.extension,
            password,
            isPrimary: this.isPrimary
          }
        });
      } catch (error) {
        this.notifyNegative(error.message);
      }
      this.saving = false;
    },
    handleSubmit() {
      this.validate(['number', 'extension']);

      if (this.isPrimary) {
        this.$refs.phoneNumberPasswordDialogRef.openDialog(this.handleSave);
      } else {
        this.handleSave();
      }
    }
  }
};
</script>

<style></style>
